import { Button, Paragraph, YStack } from '@my/ui'
import { ChevronLeft } from '@tamagui/lucide-icons-2'

export function UserDetailScreen() {

  return (
    <YStack f={1} justifyContent="center" alignItems="center" gap="$4" bg="$background">
      <Button icon={ChevronLeft}>
        Go Home
      </Button>
    </YStack>
  )
}
